
<template>
  <div class="regi-container">
    <div class="regi-pager">

      <div class="header">
        <div class="logo">
          <img src="/imgs/LOGO.png" alt="Logo" />
        </div>
        <h2>🎉 로그인에 성공하셨습니다</h2>
        <p>서비스 이용을 위해 아래 정보를 입력해 주세요</p>
      </div>
      
      <form @submit.prevent="fnLogin">
        <Swiper
          :initialSlide="0"
          :slides-per-view="1"
          :space-between="24"
          ref="mySwiper"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          :allow-touch-move="false"
          >

          <!-- 닉네임/이름 -->
          <SwiperSlide class="swiper-slide">
            <label for="user_name">이름</label>
            <input @keydown="onTab" type="text" name="user_name" placeholder="이름 입력" v-model="user_name" @input="sanitize('user_name')" required maxlength="16" pattern="^[a-zA-Z가-힣ㄱ-ㅎ\s]+$">
            
            <label for="user_nick">닉네임</label>
            <input @keydown="onTab" type="text" name="user_nick" placeholder="닉네임 입력" v-model="user_nick" @input="sanitize('user_nick')" required maxlength="16" pattern="^[a-zA-Z가-힣ㄱ-ㅎ\s]+$">
          </SwiperSlide>

          <!-- 생일/성별 -->
          <SwiperSlide class="swiper-slide">
            <label for="user_birth">생년월일</label>
            <input 
              @keydown="onTab" type="number" name="user_birth" placeholder="ex) 941014" v-model="user_birth" @input="sanitize('user_birth')" required maxlength="6"
            />

            <label>성별</label>
            <div class="gender-options">
              <label for="sex_m" :class="{ sel: user_gender === 'M' }"> <input type="radio" name="user_gender" id="sex_m" value="M" v-model="user_gender" required /> <i class="ph ph-gender-male"></i>남성 </label>
              <label for="sex_f" :class="{ sel: user_gender === 'F' }"> <input type="radio" name="user_gender" id="sex_f" value="F" v-model="user_gender" required /> <i class="ph ph-gender-female"></i>여성 </label>
            </div>
          </SwiperSlide>

          <!-- 전화번호 -->
          <SwiperSlide class="swiper-slide">

            <div class="pack">
              <label for="user_phone">전화번호</label>
              <p class="alert" v-if="alert_send_auth">{{ alert_send_auth }}</p>
              <input @keydown="onTab" type="tel" name="user_phone" placeholder="숫자만 입력" v-model="user_phone" required maxlength="13" />

              <button type="button" @click="sendVerificationCode"> 인증 발송 </button>
            </div>

            <div class="pack">
              <label for="verify_code">인증번호 입력</label>
              <p class="alert" v-if="alert_auth_verfiy">{{ alert_auth_verfiy }}</p>
              <input @keydown="onTab" type="text" name="verify_code" v-model="verify_code" placeholder="인증번호 입력" maxlength="6" />

              <button type="button" @click="verifyCode"> 인증 확인 </button>
            </div>
    
          </SwiperSlide>

        </Swiper>
        <div class="bottom-nav">
          <button type="button" @click="prev()">이전</button>
          <button type="button" @click="next()">다음</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { ref, inject } from "vue";

export default {
  name: 'MainPage',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {

    };
  },
  setup() {
    const SMS_sendAuthCode = inject("SMS_sendAuthCode");
    const SMS_verifyAuthCode = inject("SMS_verifyAuthCode");
    const getMbid = inject("getMbid");
    const member_info = inject("member_info");
    const sql_query = inject("sql_query");
    const alert_send_auth = ref('');
    const alert_auth_verfiy = ref('');
    const verfiyed = ref(false);
    const user_name = ref('');
    const user_nick = ref('');
    const user_birth = ref('');
    const user_gender = ref('');
    const user_phone = ref('');
    const user_citizen_number = ref('');
    const verify_code = ref('');
    const mySwiper = ref(null);
    

    function onTab(event) {
      if (event.key === "Tab") {
        event.preventDefault(); // Tab 키 기본 동작 방지
      }
    }

    function onSwiper(swiper) {
      console.log("Swiper initialized:", swiper);
      mySwiper.value = swiper;
    }

    function onSlideChange(swiper) {
      console.log("Slide changed to:", swiper.activeIndex);
    }

    // 필드별 sanitize 처리
    function sanitize(field) {
      if (field === 'user_name') { user_name.value = user_name.value.replace(/[^a-zA-Z가-힣\s]/g, ''); }
      if (field === 'user_nick') { user_nick.value = user_nick.value.replace(/[^a-zA-Z가-힣\s]/g, ''); }
    }

    function sendVerificationCode() {
      alert_send_auth.value = `인증번호가 ${user_phone.value}로 발송되었습니다.`;
      SMS_sendAuthCode(`${user_phone.value}`)
        .then(return_value => { console.log("메시지 전송 됨", return_value) });
    }

    function verifyCode() {
      if (!verfiyed.value) {
        SMS_verifyAuthCode(user_phone.value, verify_code.value)
          .then(return_value => {
            if (return_value.success === true) {
              verfiyed.value = true;
              alert_auth_verfiy.value = "인증되었습니다.";
            } else {
              alert_auth_verfiy.value = "인증번호가 틀립니다.";
            }
          });
      } else {
        alert("이미 인증 되었습니다.");
      }
    }

    function prev() {
      mySwiper.value.slidePrev();
    }

    function next() {
      const step = mySwiper.value.activeIndex;

      if (step === 0) {
        if (!user_name.value || !user_nick.value) return alert("이름과 닉네임을 입력하세요");
      }

      if (step === 1) {
        if (!user_birth.value || !user_gender.value) return alert("생일과 성별을 선택하세요");
      }

      if (step === 2) {
        if (!user_phone.value || !verify_code.value) return alert("전화번호와 인증번호를 입력하세요");
        // TODO: 인증번호 검증 API 연동
        // TODO: 전체 데이터 전송
        updateUserInfo(); // 저장 호출
        return;
      }

      mySwiper.value.slideNext();
    }

    async function updateUserInfo() {

      if (!user_name.value || !user_nick.value || !user_birth.value) {
        return alert("모든 필드를 입력하세요");
      }

      if (user_birth.value.length === 6) {
        const year = parseInt(user_birth.value.substring(0, 2), 10);
        const month = parseInt(user_birth.value.substring(2, 4), 10);
        const day = parseInt(user_birth.value.substring(4, 6), 10);

        const currentYear = new Date().getFullYear();
        const cutoff = currentYear % 100; // 예: 2025 → 25

        // year가 cutoff보다 작거나 같으면 20XX, 아니면 19XX
        const fullYear = year <= cutoff ? 2000 + year : 1900 + year;

        // 성별 코드 설정
        let genderCode = '';
        if (user_gender.value === 'M') {
          genderCode = fullYear < 2000 ? '1' : '3';
        } else if (user_gender.value === 'F') {
          genderCode = fullYear < 2000 ? '2' : '4';
        }

        // user_birth 보정
        user_birth.value = `${fullYear}${month.toString().padStart(2, '0')}${day.toString().padStart(2, '0')}`;
        user_citizen_number.value = `${user_birth.value.substring(2)}-${genderCode}`;
      }
      
      const sql = `UPDATE member SET 
        name = '${user_name.value}', 
        nickname = '${user_nick.value}',
        citizen_number = '${user_citizen_number.value}',
        phone = '${user_phone.value}'
        WHERE mb_id = '${getMbid()}'`;

      await sql_query(sql);
      window.location = "/";
    }

    return {
      onSwiper,
      onSlideChange,
      Swiper,
      SwiperSlide,
      sanitize,
      prev,
      next,
      sendVerificationCode,
      verifyCode,
      updateUserInfo,
      user_phone,
      user_birth,
      user_gender,
      user_name,
      user_nick,
      verify_code,
      mySwiper,
      alert_send_auth,
      alert_auth_verfiy,
      member_info,
      onTab
    };
  }
}
</script>



<style scoped>


html,
body {
  background: var(--color-primary) !important;
}

.regi-container { 
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
}

.regi-container .regi-pager { 
  width: 100%;
  max-width: var(--break-point-480);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--font-size-xl);
  box-sizing: border-box;
  border-radius: var(--font-size-xs);
}

.regi-container .regi-pager > .header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--font-size-md);
}

.regi-container .regi-pager > .header > .logo > img {
  width: var(--font-size-5xl);
  height: var(--font-size-5xl);
  object-fit: cover;
}

.regi-container .regi-pager > .header > h2 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-extrabold);
  padding:0;
  margin: 0;
}

.regi-container .regi-pager > .header > p {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--color-text-light);
  padding:0;
  margin: 0;
}

.regi-container .regi-pager form { 
  width: 100%;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--font-size-md);
}

.regi-container .regi-pager form > .swiper-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--font-size-md);
}

.regi-container .regi-pager form > .swiper-container > .swiper-wrapper > .swiper-slide {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--font-size-xl);
  box-sizing: border-box;
  border-radius: var(--font-size-xs);
  background-color: var(--color-white);
}

.regi-container .regi-pager form > .swiper-container > .swiper-wrapper > .swiper-slide input {
  width: 100%;
  padding: var(--font-size-xl);
  height: var(--font-size-5xl);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  border: solid var(--color-text-secondary) 1px;
  border-radius: var(--font-size-md);
  background: var(--color-primary);
  margin: 0;
  box-sizing: border-box;
}

.regi-container .regi-pager form > .swiper-container > .swiper-wrapper > .swiper-slide input:focus {
  outline: none;
  border: solid var(--color-brand) 1px;
  box-shadow: 0px 0px 5px var(--color-brand);
}

.regi-container .regi-pager form > .swiper-container > .swiper-wrapper > .swiper-slide label {
  width: 100%;
  font-size: var(--font-size-md);
}

.regi-container .regi-pager form > .swiper-container > .swiper-wrapper > .swiper-slide .pack {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--font-size-md);
  gap:12px;
}

.regi-container .regi-pager form > .swiper-container > .swiper-wrapper > .swiper-slide .pack > button {
  position: absolute;
  top:45px;
  right:12px;
  width: fit-content;
  height: fit-content;
  border-radius: 12px;
  margin:0;
  border: 0;
  padding:6px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  background-color: var(--color-brand);
  color: var(--color-text-black);
  cursor: pointer;
}

.regi-container .regi-pager form > .bottom-nav {
  width: 100%;
  height: var(--font-size-5xl);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--font-size-xl);
}

.regi-container .regi-pager form > .bottom-nav > button {
  width: 50%;
  height: var(--font-size-5xl);
  border-radius: 100px;
  margin:0;
  border: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  background-color: var(--color-brand);
  color: #fff;
  cursor: pointer;
}

.gender-options {
  width:100%;
  display: flex;
  gap: 16px;
  font-size: var(--font-size-md);
}

.gender-options > label {
  width:100%;
  flex:1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 6px;
  background:var(--color-background-light);
  height: var(--font-size-5xl);
  border-radius: var(--font-size-md);
  cursor:pointer;
}

.gender-options > label.sel {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.gender-options > label input {
  position: absolute;
  opacity: 0;
  width: 0 !important;
  height: 0 !important;
}

</style>
